(() => {
const C = window.JoffzProductConfigurator;
if (!C) return;
Object.assign(C.prototype, {
setMaterial(material) {
const input = this.materialInputs.find((candidate) => candidate.value === material && !candidate.disabled);
if (input) input.checked = true;
},
setFrame(material, frame) {
const exactInput = this.frameInputs.find(
(candidate) =>
candidate.dataset.materialScope === material &&
candidate.value === frame &&
!candidate.disabled
);
const input = exactInput || this.findUsableFrameInput(material);
if (input) input.checked = true;
},
setMount(mount) {
const exactInput = this.mountInputs.find(
(candidate) => candidate.value === mount && !candidate.disabled
);
const fallbackInput = this.mountInputs.find(
(candidate) => candidate.value === 'no' && !candidate.disabled
);
const input = exactInput || fallbackInput;
if (input) input.checked = true;
},
setSize(size) {
const input = this.sizeInputs.find((candidate) => candidate.value === size);
if (input) input.checked = true;
},
updateUrl(variantId, replace = false) {
const url = new URL(window.location.href);
if (url.searchParams.get('variant') === String(variantId) && !replace) return;
url.searchParams.set('variant', String(variantId));
const state = { ...(history.state || {}), joffzVariantId: String(variantId) };
if (replace) {
history.replaceState(state, '', url.toString());
} else {
history.pushState(state, '', url.toString());
}
},
combinationKey(finish, size) {
return `${this.normalize(finish)}::${this.normalize(size)}`;
},
normalize(value) {
return String(value || '')
.trim()
.toLocaleLowerCase('en')
.replace(/\s+/g, ' ');
},
announce(message) {
if (this.statusElement) this.statusElement.textContent = message || '';
},
adjustQuantity(delta) {
if (!this.quantityInput) return;
const current = Number.parseInt(this.quantityInput.value, 10) || 1;
this.quantityInput.value = String(Math.max(1, current + delta));
this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
},
sanitizeQuantity() {
if (!this.quantityInput) return;
const value = Number.parseInt(this.quantityInput.value, 10);
this.quantityInput.value = String(Number.isFinite(value) && value > 0 ? value : 1);
},
openSizeGuide() {
if (!this.sizeDialog) return;
if (typeof this.sizeDialog.showModal === 'function') {
this.sizeDialog.showModal();
} else {
this.sizeDialog.setAttribute('open', '');
}
},
closeSizeGuide() {
if (!this.sizeDialog) return;
if (typeof this.sizeDialog.close === 'function') {
this.sizeDialog.close();
} else {
this.sizeDialog.removeAttribute('open');
}
this.sizeGuideOpen?.focus({ preventScroll: true });
}
});
})();
